<template>
  <div>
    <dv-loading v-if="loading">Loading...</dv-loading>
    <div v-else
         class="board-container">
      <div class="board-header">
        <div style="color: #06f1ef;text-align: center;font-size: 26px;font-weight: bold;">
          <dv-decoration-5 :dur="2"
                           :color="['#568aea', '#568aea']"
                           style="width: 250px; height: 30px" />
          <div>异地库可视化平台</div>
          <dv-decoration-6 :reverse="true"
                           :color="['#50e3c2', '#67a1e5']"
                           style="width: 250px; height: 10px" />
        </div>
        <div class="time-container">
          <dv-decoration-7 style="color: #06f1ef;font-size: 16px;">{{timeText}}</dv-decoration-7>
        </div>
        <div class="btn-container">
          <el-button @click="hideMenu">隐藏菜单</el-button>
        </div>
      </div>
      <div class="board-content">
        <div class="content-top">
          <div class="content-top-left">
            <div class="store-row"
                 v-for="(item, index) in storeData"
                 :key="`row${index}`">
              <div class="store-item"
                   v-for="(it, ix) in item"
                   :key="`item${ix}`">
                <dv-border-box-8>
                  <div class="store-item-content">
                    <div class="store-item-content__title"
                         @click="handleToStore(it)">
                      <span>{{ it.title }}</span>
                    </div>
                    <div class="store-item-content__category">
                      <span>分类</span>
                      <span>{{ it.category }}</span>
                    </div>
                    <div class="store-item-content__total">
                      <span>总量</span>
                      <span>{{ it.data }}吨</span>
                    </div>
                  </div>
                </dv-border-box-8>
              </div>
            </div>
          </div>
          <div class="content-top-center">
            <dv-border-box-7>
              <china></china>
            </dv-border-box-7>
          </div>
          <div class="content-top-right">
            <dv-border-box-3>
              <system-pie :chartData="systemData"></system-pie>
            </dv-border-box-3>
          </div>
        </div>
        <div class="content-bottom">
          <dv-border-box-10>
            <top-table title="预警"
                       :tableData="warningData"></top-table>
          </dv-border-box-10>
          <dv-border-box-1>
            <in-out-chart :chartData="inOutData"></in-out-chart>
          </dv-border-box-1>
        </div>
        <div></div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapActions } from 'vuex'
import SystemPie from './components/systemPie'
import InOutChart from './components/inOutChart'
import TopTable from './components/topTable'
import China from './components/china'

// const SYSTEM_TYPE = ['成品油', '碳材料', '化工品', '聚烯烃', '沥青']
const YDK_NAME = { LFDK: '利丰达库区', FLK: '丰利库区' }
export default {
  name: 'ydkBoard',
  components: {
    SystemPie,
    InOutChart,
    TopTable,
    China
  },
  data () {
    return {
      loading: true,
      timeText: '', // 时间
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      systemData: [],
      storeData: [],
      // storeData2: [
      //   [
      //     { title: '利丰达库区', category: '成品油1', data: 10000 },
      //     { title: '丰利库区', category: '成品油2', data: 10000 },
      //     { title: '模拟库区1', category: '成品油3', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区2', category: '成品油4', data: 10000 },
      //     { title: '模拟库区3', category: '成品油5', data: 10000 },
      //     { title: '模拟库区4', category: '成品油6', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区5', category: '成品油7', data: 10000 },
      //     { title: '模拟库区6', category: '成品油8', data: 10000 },
      //     { title: '模拟库区7', category: '成品油9', data: 10000 }
      //   ],
      //   [
      //     { title: '模拟库区5', category: '成品油7', data: 10000 },
      //     { title: '模拟库区6', category: '成品油8', data: 10000 },
      //     { title: '模拟库区7', category: '成品油9', data: 10000 }
      //   ]
      // ],
      inOutData: {
        xAxisData: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        monthTotal: new Array(12).fill(0),
        inQuantity: new Array(12).fill(0),
        outQuantity: new Array(12).fill(0)
      },
      warningData: []
    }
  },
  created () { },
  mounted () {
    this.init()
    // 看板添加横向滚动条
    this.$nextTick(() => {
      const dom = document.querySelector('.main-view')
      if (dom) {
        dom.style.overflowX = 'scroll'
      }
    })
  },
  methods: {
    ...mapActions(['queryYDKBoardData']),
    timeFn () {
      // 获取时间
      setInterval(() => {
        const now = new Date()
        this.timeText = `${now.toLocaleString()} ${this.weekday[now.getDay()]}`
      }, 1000)
    },
    async init () {
      this.loading = true
      try {
        this.timeFn()
        const result = await this.queryYDKBoardData()
        const { data } = result
        if (data) {
          const { itemTypeSumMap, monthInventoryNumList, monthNumList, forewarningList } = data
          // 体系图表及库区最高库存
          if (itemTypeSumMap) {
            const storeArr = []
            const systemArr = []
            Object.keys(itemTypeSumMap).forEach((key) => {
              const storeObj = {
                title: YDK_NAME[key],
                category: '',
                data: 0
              }
              // const seriesData = new Array(5).fill(0)
              if (
                Array.isArray(itemTypeSumMap[key]) &&
                itemTypeSumMap[key].length > 0
              ) {
                itemTypeSumMap[key].forEach((item) => {
                  const { itemType, quantity } = item
                  const curr = systemArr.find(it => it.name === itemType)
                  if (curr) {
                    curr.value += quantity
                  } else {
                    systemArr.push({ name: itemType, value: quantity })
                  }

                  // const idx = SYSTEM_TYPE.indexOf(itemType)
                  // if (idx > -1) {
                  //   seriesData[idx] = quantity
                  // }
                  if (quantity > storeObj.data) {
                    storeObj.data = quantity
                    storeObj.category = itemType
                  }
                })
              }
              // const seriesObj = {
              //   name: YDK_NAME[key],
              //   type: 'bar',
              //   stack: 'total',
              //   label: {
              //     show: true,
              //     formatter: (config) => {
              //       const { seriesName, value } = config
              //       return value ? `${seriesName}:${value}` : ''
              //     }
              //   },
              //   emphasis: {
              //     focus: 'series'
              //   },
              //   data: seriesData
              // }
              storeArr.push(storeObj)
              // this.systemData.push(seriesObj)
            })
            this.convertStoreData(storeArr)
            this.systemData = systemArr
          }
          // 出入库图表数据
          if (
            Array.isArray(monthInventoryNumList) &&
            monthInventoryNumList.length > 0 &&
            Array.isArray(monthNumList) &&
            monthNumList.length > 0
          ) {
            monthInventoryNumList.forEach((item) => {
              const { month, quantity } = item
              this.inOutData.monthTotal.splice(month - 1, 1, quantity)
            })
            monthNumList.forEach((item) => {
              const { month, inQuantity, outQuantity } = item
              this.inOutData.inQuantity.splice(month - 1, 1, inQuantity)
              this.inOutData.outQuantity.splice(month - 1, 1, outQuantity)
            })
          }
          this.warningData = forewarningList
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    handleToStore ({ title }) {
      if (title.includes('利丰达')) {
        this.$router.push({ path: '/virtual/lfdBoard' })
      }
      if (title.includes('丰利库')) {
        this.$router.push({ path: '/virtual/flkBoard' })
      }
    },
    convertStoreData (data) {
      let storeArr = []
      for (let i = 0; i < data.length; i += 3) {
        storeArr.push(data.slice(i, i + 3))
      }
      this.storeData = storeArr
    },
    hideMenu () {
      this.$router.replace({ path: '/ydkBoard' })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .loading-tip {
  font-size: 23px !important;
  color: aqua;
  font-weight: bold;
}
.board-container {
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
  width: auto;
  min-width: 1280px;
  height: 1000px;
  display: flex;
  flex-direction: column;
  .board-header {
    height: 8%;
    position: relative;
    display: flex;
    justify-content: center;
    .time-container {
      position: absolute;
      right: 2%;
      top: 3%;
    }
    .btn-container {
      position: absolute;
      right: 4%;
      top: 30px;
    }
  }
  .board-content {
    height: 92%;
    .content-top {
      height: 50%;
      display: flex;
      .content-top-left {
        flex: 1;
        min-width: 300px;
        color: #06f1ef;
        overflow: auto;
        height: 100%;
        width: 100%;

        /* 隐藏默认的滚动条样式 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        .store-row {
          display: flex;
          height: 33.33%;
          .store-item {
            width: 33.33%;
            .store-item-content {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              .store-item-content__title,
              .store-item-content__category,
              .store-item-content__total {
                flex: 1;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                height: 30px;
                line-height: 30px;
              }
              .store-item-content__category,
              .store-item-content__total {
                font-size: 15px;
                padding-left: 12px;
                span:first-child {
                  flex: 1;
                }
                span:nth-child(2) {
                  flex: 2;
                }
              }
              .store-item-content__title {
                cursor: pointer;
                font-size: 18px;
                font-weight: bold;
              }
              .store-item-content__title:hover {
                font-weight: bold;
                font-size: 20px;
              }
            }
          }
        }
      }
      .content-top-left::-webkit-scrollbar {
        display: none; /* Chrome, Safari, and Opera */
      }
      .content-top-center {
        flex: 1;
      }
      .content-top-right {
        flex: 1;
      }
    }

    .content-bottom {
      height: 50%;
      padding-top: 16px;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }
}
/* 滚动条样式 */
.main-view::-webkit-scrollbar {
  height: 8px;
}

.main-view::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.main-view::-webkit-scrollbar-thumb {
  background: #C1C1C1;
}

.main-view::-webkit-scrollbar-thumb:hover {
  background: #A8A8A8;
}

.main-view::-webkit-scrollbar-button {
  background: #f1f1f1;
}

.main-view::-webkit-scrollbar-corner {
  background: #f1f1f1;
}
</style>
